import * as _ from "lodash";
import pathToRegexp from "path-to-regexp";
import { useMappedState } from "redux-react-hook";
import * as React from "react";

import tokenizeString from "src/library/utils/string-manipulations/tokenize-string";
import type { IStore } from "src/core/shared/store";
import type { IRoute } from "src/pages/Router/routes";

const useGetMenuItemByPath = () => {
  const { terminology } = useMappedState(({ global }: IStore) => ({ terminology: global.settings && global.settings.terminology }));

  const getMenuItemByPath = React.useCallback(
    (path: string, routes: IRoute[]) => {
      if (terminology) {
        if (path) {
          const matchingRoute = _.find(routes, route => {
            if (route.path && route.pageComponent) {
              const regexp = pathToRegexp(route.path);

              if (regexp.exec(path)) {
                return true;
              }
            }

            return false;
          });

          if (matchingRoute) {
            matchingRoute.title = tokenizeString(matchingRoute.menuTitle || matchingRoute.title, terminology);

            return matchingRoute;
          }
        }
      }

      return;
    },
    [ terminology ]
  );

  return getMenuItemByPath;
};

export default useGetMenuItemByPath;
